module.exports = __webpack_public_path__ + "img/note.29c5b0d1.svg";